import * as Constants from '@/lib/constants'

export default class CachedData {
  constructor(timestamp, value) {
    this.timestamp = timestamp
    this.value = value
  }

  touch() {
    this.timestamp = Date.now()
  }

  isExpired() {
    return this.timestamp + Constants.STORAGE_CACHE_DEFAULT_EXPIRE_SECONDS * 1000 < Date.now()
  }
}
